import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-4">
      <div className="container mx-auto text-center">
        <p>&copy; 2024 Startup Board. All rights reserved.</p>
        <p>Follow us on <a href="https://github.com/krishna7054" className="text-blue-500">GitHub</a> and <a href="https://www.linkedin.com/in/krishna-kumar-rgipt/" className="text-blue-500">LinkedIn</a></p>
      </div>
    </footer>
  );
};

export default Footer;
